import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingBarService {
  isBusy = false;
  loaderIndex = 0;

  constructor() {}

  set(val: boolean) {
    if (val === true) {
      this.loaderIndex++;
    } else {
      this.loaderIndex--;
    }
    if (this.loaderIndex > 0) {
      this.isBusy = true;
    } else {
      this.isBusy = false;
    }
    //this.isBusy = val;
  }
  get() {
    return this.isBusy;
  }
}
